module.exports = __webpack_public_path__ + "static/media/geometryImage.18b8c82a.svg";